module.exports = __webpack_public_path__ + "img/2.76ab2b80.jpg";